import React, { useState } from "react";
import { Box, AppBar, Toolbar, Typography, Button, IconButton, Menu, Link as MuiLink, MenuItem } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../AuthContext";



const Navbar = ({isSubmit}) => {
  const { isAdmin, user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  return (
    <Box sx={{ flexGrow: 1, borderBottom: 1, borderColor: 'grey.500'}}>
        <AppBar position="static" color="main" elevation={0} sx={{ paddingBottom:'10px'}}>
            <Toolbar sx={{justifyContent: 'space-between' }}>
                <Box sx={{display: 'flex', alignItems: 'center', marginTop: '11px'}} href="https://mdtf.org/">
                    <img src="../../images/MdTF_Logo_Monitor.jpg" width="95" height="60" alt="logo"/>
                    <Typography color="fontTheme" sx={{fontWeight:'bold', fontSize:'10px'}}>
                        CONSOLE
                    </Typography>
                </Box>
                <Box sx={{display: 'flex', marginTop: '11px', marginLeft: '30px'}}>
                  <Box sx={{display: 'flex', alignItems: 'center'}}>
                      <Typography color="fontTheme" className="navbar-email">
                          {user.email} <b>|</b> {user.company} ({user.role.charAt(0).toUpperCase() + user.role.slice(1)})
                      </Typography>
                  </Box>
                  <IconButton disabled={isSubmit}>
                    <MenuIcon color='fontTheme' 
                              sx={{fontSize: 35}}
                              onClick={handleClick} />
                  </IconButton>
                  
                  {isAdmin ?
                  <Menu id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'bottom',  
                          horizontal: 'right',  
                        }}
                        transformOrigin={{
                          vertical: 'top',    
                          horizontal: 'right',  
                        }}
                        slotProps={{
                          paper: {
                            style: {
                              backgroundColor: '#e5eaef',
                              width: '225px',
                              height: '190px',
                              marginTop: '25px'
                            },
                          },
                        }}
                        sx={{width: '225px'}}>
                    <MenuItem onClick={handleClose} disabled sx={{width: '100%', display: 'none', justifyContent: 'left', marginTop: '30px'}} >
                      <MuiLink component={RouterLink}
                              underline="none" 
                              color="fontTheme">
                        <Typography color='fontTheme' sx={{paddingLeft: '20px'}}>
                          MY ACCOUNT
                        </Typography>
                      </MuiLink>
                    </MenuItem>
                    <MenuItem onClick={handleClose} sx={{width: '100%', display: 'flex', justifyContent: 'left', marginTop: '30px'}} >
                      <MuiLink component={RouterLink}
                              underline="none" 
                              color="fontTheme">
                        <Typography color='fontTheme' sx={{paddingLeft: '20px'}}>
                          Release: v1.2.0
                        </Typography>
                      </MuiLink>
                    </MenuItem>
                    <MenuItem onClick={handleClose} sx={{width: '100%', display: 'flex', justifyContent: 'left', marginBottom: '30px', marginTop: '30px'}}  >
                      <MuiLink component={RouterLink} 
                              to="/user-admin"
                              underline="none" 
                              color="fontTheme">
                        <Typography color='fontTheme' sx={{paddingLeft: '20px'}}>
                          USER ADMIN
                        </Typography>
                      </MuiLink>
                    </MenuItem>
                    <MenuItem onClick={handleClose} sx={{width: '100%', display: 'none', justifyContent: 'left', marginBottom: '30px'}} >
                      <MuiLink component={RouterLink}
                              underline="none" 
                              color="fontTheme">
                        <Typography color='fontTheme' sx={{paddingLeft: '20px'}}>
                          ABOUT
                        </Typography>
                      </MuiLink>
                    </MenuItem>
                    <Box sx={{width: '100%', display: 'flex', justifyContent: 'center'}} >
                      <Button variant="outlined" 
                              color='fontTheme'
                              component={RouterLink}
                              to='/login'
                              sx={{backgroundColor: "white"}}
                              onClick={logout}>
                        LOGOUT
                      </Button>
                    </Box>
                  </Menu>
                  :
                  <Menu id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'bottom',  
                          horizontal: 'right',  
                        }}
                        transformOrigin={{
                          vertical: 'top',    
                          horizontal: 'right',  
                        }}
                        slotProps={{
                          paper: {
                            style: {
                              backgroundColor: '#e5eaef',
                              width: '225px',
                              height: '170px',
                              marginTop: '25px'
                            },
                          },
                        }}
                        sx={{width: '225px'}}>
                    <MenuItem onClick={handleClose} disabled sx={{width: '100%', display: 'none', justifyContent: 'left', marginTop: '30px'}} >
                      <MuiLink component={RouterLink}
                              underline="none" 
                              color="fontTheme">
                        <Typography color='fontTheme' sx={{paddingLeft: '20px'}}>
                          MY ACCOUNT
                        </Typography>
                      </MuiLink>
                    </MenuItem>
                    <MenuItem onClick={handleClose} sx={{width: '100%', display: 'flex', justifyContent: 'left', marginTop: '30px'}} >
                      <MuiLink component={RouterLink}
                              underline="none" 
                              color="fontTheme">
                        <Typography color='fontTheme' sx={{paddingLeft: '20px'}}>
                          Release: v1.2.0
                        </Typography>
                      </MuiLink>
                    </MenuItem>
                    <MenuItem onClick={handleClose} sx={{width: '100%', display: 'none', justifyContent: 'left', marginBottom: '30px'}} >
                      <MuiLink component={RouterLink}
                              underline="none" 
                              color="fontTheme">
                        <Typography color='fontTheme' sx={{paddingLeft: '20px'}}>
                          ABOUT
                        </Typography>
                      </MuiLink>
                    </MenuItem>
                    <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', marginTop: '30px'}} >
                      <Button variant="outlined" 
                              color='fontTheme'
                              component={RouterLink}
                              to='/login'
                              sx={{backgroundColor: "white"}}
                              onClick={logout}>
                        LOGOUT
                      </Button>
                    </Box>
                  </Menu>
                  }
                </Box>
            </Toolbar>
        </AppBar>
    </Box>
  );
};

export default Navbar;